import * as React from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";
import { cn } from "@/lib/utils";

function Switch({
    className,
    ...props
}: React.ComponentProps<typeof SwitchPrimitives.Root>) {
    return (
        <SwitchPrimitives.Root
            data-slot="switch"
            className={cn(
                "peer shrink-0 cursor-pointer rounded-full border-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 disabled:cursor-not-allowed disabled:opacity-50",
                className?.includes("gs-prod-switch")
                    ? className
                    : cn(
                          "inline-flex h-6 w-11 items-center bg-muted transition-colors data-[state=checked]:bg-primary",
                          className
                      )
            )}
            {...props}
        >
            <SwitchPrimitives.Thumb
                data-slot="switch-thumb"
                className={cn(
                    "pointer-events-none block h-4 w-4 shrink-0 rounded-full bg-white shadow-sm ring-0",
                    className?.includes("gs-prod-switch")
                        ? undefined
                        : "transition-transform duration-200 ease-in-out data-[state=checked]:translate-x-5"
                )}
            />
        </SwitchPrimitives.Root>
    );
}

export { Switch };
